import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, ArrowRight } from 'lucide-react';
const components = [{
  title: 'Kit Calma Total',
  desc: 'Sistema base con estrategias visuales, estructura simple y herramientas prácticas para bajar caos diario.',
  isBase: true
}, {
  title: 'Bono 1 — Kit Express de Crisis en 5 Minutos',
  desc: 'Qué hacer exactamente cuando tu hijo entra en desborde.'
}, {
  title: 'Bono 2 — Guiones Calmos para Momentos Difíciles',
  desc: 'Las palabras exactas para no escalar más el conflicto.'
}, {
  title: 'Bono 3 — Rutina Anticaos de Mañana y Noche',
  desc: 'La estructura práctica para los dos momentos más caóticos del día.'
}, {
  title: 'Regalo Especial — Tablero Maestro de la Semana en Calma',
  desc: 'Sistema imprimible y editable para organizar semana, escuela, terapias, emociones y cambios de plan.',
  isGift: true
}];
export function Solution() {
  const scrollToOffer = () => {
    document.getElementById('oferta')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-20 bg-ocean-blue" data-id="element-183">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-184">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-185">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-186">
            La solución que estabas necesitando — un sistema listo para usar
          </h2>
          <p className="text-lg text-gray-600" data-id="element-187">
            KIT CALMA TOTAL no es un ebook genérico. Es un sistema práctico con
            herramientas aplicables desde el día 1.
          </p>
        </div>

        <div className="max-w-4xl mx-auto space-y-4" data-id="element-188">
          {components.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className={`p-6 md:p-8 rounded-2xl flex flex-col md:flex-row gap-4 md:items-center shadow-sm border ${item.isBase ? 'bg-ocean-teal text-white border-ocean-teal-dark' : item.isGift ? 'bg-ocean-gold-light border-ocean-gold/20' : 'bg-white border-gray-100'}`} data-id="element-189">
              <div className="flex-shrink-0" data-id="element-190">
                <CheckCircle2 className={`w-8 h-8 ${item.isBase ? 'text-white' : item.isGift ? 'text-ocean-gold-dark' : 'text-ocean-teal'}`} data-id="element-191" />
              </div>
              <div data-id="element-192">
                <h3 className={`text-xl font-bold mb-1 ${item.isBase ? 'text-white' : 'text-gray-900'}`} data-id="element-193">
                  {item.title}
                </h3>
                <p className={`${item.isBase ? 'text-ocean-teal-light' : 'text-gray-600'}`} data-id="element-194">
                  {item.desc}
                </p>
              </div>
            </motion.div>)}
        </div>

        <div className="mt-12 text-center" data-id="element-195">
          <button onClick={scrollToOffer} className="inline-flex items-center gap-2 px-8 py-4 bg-white text-ocean-teal border-2 border-ocean-teal hover:bg-ocean-teal hover:text-white rounded-xl font-semibold text-lg transition-colors shadow-sm" data-id="element-196">
            VER OPCIONES DE COMPRA
            <ArrowRight className="w-5 h-5" data-id="element-197" />
          </button>
        </div>
      </div>
    </section>;
}